export const trimStringsRecursively = obj => {
    Object.keys(obj).forEach(key => {
        if (typeof obj[key] === 'string') {
            obj[key] = obj[key].trim();
        } else if (typeof obj[key] === 'object') {
            trimStringsRecursively(obj[key]);
        }
    });
};
